<template>
  <div>
    <div style="display:flex; flex-direction:column; gap:4px;">
      <div
        style="margin-bottom:3px; font-weight:500; color:#666; font-size:14px;"
      >
        ②対象モニタリングポストを選択してください。条件入力でモニタリングポストの絞込みを行います。
      </div>

      <div style="display:flex; gap:16px; flex-wrap:wrap;">
        <!-- 左側エリア: 基本検索条件 -->
        <div style="display:flex; flex-direction:column; gap:4px;">
          <div style="display:flex; align-items:center; gap:8px;">
            <div class="vtf-field" style="width:120px;">
              <input
                v-model="searchFilters.monitoringName"
                type="text"
                placeholder=" "
                maxlength="50"
              />
              <label>地点名</label>
            </div>
            <div class="hint">部分一致</div>
          </div>
          <div style="display:flex; align-items:center; gap:8px;">
            <div class="vtf-field" style="width:120px;">
              <input
                v-model="searchFilters.monitoringLocation"
                type="text"
                placeholder=" "
                maxlength="50"
              />
              <label>設置場所</label>
            </div>
            <div class="hint">部分一致</div>
          </div>
          <div style="margin:1px 0;">
            <div style="font-weight:500; color:#666; font-size:12px;">
              原発からの直線距離
            </div>
            <div class="range-field">
              <input
                v-model="searchFilters.distanceFrom"
                type="text"
                name="distanceFrom"
                maxlength="6"
                autocomplete="off"
                @input="validateRange"
              />
              <span>〜</span>
              <input
                v-model="searchFilters.distanceTo"
                type="text"
                name="distanceTo"
                maxlength="6"
                autocomplete="off"
                @input="validateRange"
              />
              <span>km</span>
            </div>
          </div>
        </div>

        <!-- 中央エリア: 方角選択 -->
        <div
          style="display:flex; flex-direction:column; gap:4px; align-items:center;"
        >
          <div style="font-weight:500; color:#666; font-size:12px;">
            原発からの方角（複数可）
          </div>
          <SelectDirection ref="selectDirection" />
        </div>

        <!-- 右側エリア: モニタリングポスト一覧 -->
        <div style="flex:1;">
          <div class="monitoring-table-container">
            <table class="table monitoring-table">
              <thead>
                <tr>
                  <th rowspan="2">地点名</th>
                  <th rowspan="2">設置場所</th>
                  <th colspan="2">原発からの</th>
                </tr>
                <tr>
                  <th>方角</th>
                  <th>距離</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="post in filteredMonitoringPosts"
                  :key="post.station_id"
                  style="cursor:pointer;"
                  :class="{
                    selected: selectedPosts.includes(post.station_id),
                    'not-selected': !selectedPosts.includes(post.station_id)
                  }"
                  @click="togglePostSelection(post.station_id)"
                >
                  <td>{{ post.station_name }}</td>
                  <td>{{ post.installation }}</td>
                  <td>{{ post.direction_from_npp_name }}</td>
                  <td>{{ post.distance_from_npp }} km</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- 選択ボタン -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="btn-primary" @click="addSelectedPosts">
              対象選択
            </v-btn>
            <v-btn class="btn-secondary" @click="removeSelectedTargetPosts">
              対象解除
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>

          <!-- 対象モニタリングポスト一覧 -->
          <h4 style="margin:0 0 8px 0; font-size:14px;">
            対象モニタリングポスト一覧
          </h4>
          <div class="monitoring-table-container">
            <table class="table monitoring-table">
              <thead>
                <tr>
                  <th rowspan="2">地点名</th>
                  <th rowspan="2">設置場所</th>
                  <th colspan="2">原発からの</th>
                </tr>
                <tr>
                  <th>方角</th>
                  <th>距離</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="post in targetPosts"
                  :key="post.station_id"
                  style="cursor:pointer;"
                  :class="{
                    selected: selectedTargetPosts.includes(post.station_id),
                    'not-selected': !selectedTargetPosts.includes(
                      post.station_id
                    )
                  }"
                  @click="toggleTargetPostSelection(post.station_id)"
                >
                  <td>{{ post.station_name }}</td>
                  <td>{{ post.installation }}</td>
                  <td>{{ post.direction_from_npp_name }}</td>
                  <td>{{ post.distance_from_npp }} km</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
    SelectDirection: () => import("@/components/adjustment/SelectDirection")
  },
  data: () => ({
    selectedPosts: [],
    targetPosts: [],
    selectedTargetPosts: [],
    monitoringPosts: [],
    searchFilters: {
      monitoringName: "",
      monitoringLocation: "",
      distanceFrom: null,
      distanceTo: null
    }
  }),
  computed: {
    // 検索条件のモニタリングポスト絞込み
    filteredMonitoringPosts() {
      return this.monitoringPosts.filter(post => {
        // 地点名で絞り込み
        if (
          this.searchFilters.monitoringName &&
          !post.station_name.includes(this.searchFilters.monitoringName)
        )
          return false;

        // 設置場所で絞り込み
        if (
          this.searchFilters.monitoringLocation &&
          !post.installation.includes(this.searchFilters.monitoringLocation)
        )
          return false;

        // 原発からの直線距離で絞り込み
        if (
          (this.searchFilters.distanceFrom !== null &&
            this.searchFilters.distanceFrom !== "") ||
          (this.searchFilters.distanceTo !== null &&
            this.searchFilters.distanceTo !== "")
        ) {
          const distance = parseFloat(post.distance_from_npp);
          if (
            this.searchFilters.distanceFrom !== null &&
            this.searchFilters.distanceFrom !== "" &&
            distance < this.searchFilters.distanceFrom
          )
            return false;
          if (
            this.searchFilters.distanceTo !== null &&
            this.searchFilters.distanceTo !== "" &&
            distance > this.searchFilters.distanceTo
          )
            return false;
        }

        // 原発からの方角で絞り込み
        if (
          this.$refs.selectDirection.getSelectDirection().length > 0 &&
          !this.$refs.selectDirection
            .getSelectDirection()
            .includes(post.direction_from_npp)
        )
          return false;

        return true;
      });
    }
  },
  methods: {
    setMonitoringPosts(data) {
      this.monitoringPosts = data;
    },
    getMonitoringPosts() {
      return this.targetPosts;
    },
    validateRange(e) {
      const key = e.target.name;
      let txtValue = e.target.value.replace(/[^0-9.]/g, "");
      let value = parseFloat(txtValue);
      if (isNaN(value)) {
        this.searchFilters[key] = txtValue;
      }
      if (value < 0.0) txtValue = 0.0;
      if (value > 9999.9) txtValue = 9999.9;
      this.searchFilters[key] = txtValue;
    },
    // モニタリングポスト選択
    togglePostSelection(postId) {
      const index = this.selectedPosts.indexOf(postId);
      if (index > -1) {
        this.selectedPosts.splice(index, 1);
      } else {
        this.selectedPosts.push(postId);
      }
    },
    // 対象モニタリングポスト選択
    toggleTargetPostSelection(postId) {
      const index = this.selectedTargetPosts.indexOf(postId);
      if (index > -1) {
        this.selectedTargetPosts.splice(index, 1);
      } else {
        this.selectedTargetPosts.push(postId);
      }
    },
    // 対象モニタリングポストに設定
    addSelectedPosts() {
      const postsToAdd = this.monitoringPosts.filter(post =>
        this.selectedPosts.includes(post.station_id)
      );
      this.targetPosts = [
        ...this.targetPosts,
        ...postsToAdd.filter(
          post =>
            !this.targetPosts.find(tp => tp.station_id === post.station_id)
        )
      ];
      this.selectedPosts = [];
      this.selectedTargetPosts = [];
    },
    // 対象モニタリングポストから削除
    removeSelectedTargetPosts() {
      this.targetPosts = this.targetPosts.filter(
        post => !this.selectedTargetPosts.includes(post.station_id)
      );
      this.selectedPosts = [];
      this.selectedTargetPosts = [];
    }
  }
};
</script>
